@import '../../themes/capsule.globals';

:host {
  --qr-color: var(--cpsl-color-qr-fill);
  --qr-background-color: var(--cpsl-color-qr-background);
  --qr-border-color: var(--cpsl-color-qr-border);
  --qr-border-radius: var(--cpsl-border-radius-qr-code);
  --qr-border-width: 0px;
  --qr-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  --qr-padding-top: 12px;
  --qr-padding-end: 12px;
  --qr-padding-bottom: 12px;
  --qr-padding-start: 12px;

  display: inline-block;
}

.qr-container {
  @include padding(var(--qr-padding-top), var(--qr-padding-end), var(--qr-padding-bottom), var(--qr-padding-start));

  box-sizing: border-box;

  color: var(--qr-color);

  border-style: solid;
  border-width: var(--qr-border-width);
  border-color: var(--qr-border-color);
  border-radius: var(--qr-border-radius);

  background: var(--qr-background-color);

  box-shadow: var(--qr-box-shadow);
}

.qr-code {
  width: 100%;
  height: 100%;
}
